import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useState, useEffect } from 'react'
import { unwrapResult } from '@reduxjs/toolkit'
import { toast } from '@sales-center/components'
import { getLocationDocuments } from '../api'
import { IDocumentModel } from '../typings'
import { LocationDocumentTypes } from '@user/components/Attachments/AddAttachmentsDrawer/typings'

export const useGetLocationDocs = () => {
  const dispatch = useAppDispatch()

  const [locationId, setLocationId] = useState<string>()
  const [locationDocs, setLocationDocs] = useState<IDocumentModel[]>()
  const [status, setStatus] = useState<'idle' | 'pending' | 'success' | 'fail'>(
    'idle',
  )

  useEffect(() => {
    let mounted = true

    const execute = async () => {
      if (locationId) {
        setStatus('pending')
        try {
          const result: any = await dispatch(getLocationDocuments(locationId))

          if (mounted) {
            if (getLocationDocuments.fulfilled.match(result)) {
              setLocationDocs(
                unwrapResult(result)?.filter(
                  (row) =>
                    row?.documentType != LocationDocumentTypes.CompanyDocument,
                ),
              )
              setStatus('success')
            } else {
              setStatus('fail')
              toast.error(result)
            }
          }
        } catch (error) {
          if (mounted) {
            setStatus('fail')
          }
        } finally {
          setStatus('idle')
        }
      }
    }
    execute()

    return () => {
      mounted = false
    }
  }, [dispatch, locationId])

  useEffect(() => {
    if (!locationId) {
      setLocationDocs(undefined)
    }
  }, [locationId])

  return { status, locationDocs, setLocationId }
}
